import React, { createContext, useContext, useState, useEffect } from 'react';

const EditModeContext = createContext();

export function EditModeProvider({ children }) {
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    // On mount, check if we have a valid token
    const checkToken = async () => {
      const token = localStorage.getItem('editToken');
      const wasInEditMode = localStorage.getItem('editMode') === 'true';
      
      if (token && wasInEditMode) {
        // Validate token
        try {
          const res = await fetch('/api/auth/validate', {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          
          if (res.ok) {
            setIsEditMode(true);
          } else {
            // Token invalid, clear everything
            localStorage.removeItem('editToken');
            localStorage.removeItem('editMode');
            setIsEditMode(false);
          }
        } catch (err) {
          // Can't validate, assume invalid
          localStorage.removeItem('editToken');
          localStorage.removeItem('editMode');
          setIsEditMode(false);
        }
      }
    };
    
    checkToken();
  }, []);

  useEffect(() => {
    if (isEditMode) {
      localStorage.setItem('editMode', 'true');
    } else {
      localStorage.removeItem('editMode');
    }
  }, [isEditMode]);

  return (
    <EditModeContext.Provider value={{ isEditMode, setIsEditMode }}>
      {children}
    </EditModeContext.Provider>
  );
}

export function useEditMode() {
  return useContext(EditModeContext);
}
